import { userAccountParameters } from "helpers/requests"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import Form from "./UpdateProfileForm"

const user = JSON.parse(localStorage.getItem("userData")) || {}

const UpdateProfile = () => {
  const [load, setLoad] = useState(null)
  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
  })

  const getUserParameters = async () => {
    const data = {
      orgId: "939001",
      userGlobalId: user?.userGlobalId,
    }
    const parameters = await userAccountParameters(data)
    const userParameters = parameters?.data
    if (userParameters) {
      setInitialValues(userParameters)
      setLoad(true)
    }
  }

  useEffect(() => {
    getUserParameters()
  }, [])

  console.log(initialValues)

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary">
          <Row>
            <Col>
              <div className="text-white p-4">
                <p>Update Your Profile</p>
              </div>
            </Col>
          </Row>
        </div>
        <CardBody className="pt-2 px-0">
          <div className="pt-3">
            {load ? (
              <Form
                refresh={getUserParameters}
                initialValues={initialValues}
                load={load}
              />
            ) : null} 
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

UpdateProfile.propTypes = {
  t: PropTypes.any,
}

export default UpdateProfile
